import { render, staticRenderFns } from "./delta-margins.vue?vue&type=template&id=0e559d2c&scoped=true"
import script from "./delta-margins.vue?vue&type=script&lang=js"
export * from "./delta-margins.vue?vue&type=script&lang=js"
import style0 from "./delta-margins.vue?vue&type=style&index=0&id=0e559d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e559d2c",
  null
  
)

export default component.exports